import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { snackbarStateAtom } from 'common/state/snackbarState';

import { Snackbar } from '../components/cookbook/Snackbars/types';

export const useSnackbar = () => {
  const [snackbars, setSnackbars] = useAtom(snackbarStateAtom);

  const addSnackbar = useCallback(
    ({ id, ...props }: Snackbar) => {
      const newSnackbar = {
        id: id ?? crypto.randomUUID(),
        ...props,
      };
      setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);
    },
    [setSnackbars],
  );

  const removeSnackbar = useCallback(
    (id: string) => {
      setSnackbars((prevSnackbars) => prevSnackbars.filter((snackbar) => snackbar.id !== id));
    },
    [setSnackbars],
  );
  return {
    snackbars,
    addSnackbar,
    removeSnackbar,
  };
};
